import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { FORMSPREE_CONTACT_FORM, FORMSPREE_THANK_YOU_URL, readFormspreeErrorMessage } from "../../utils/formspree";
import { trackLeadSubmission } from "../../utils/trackLead";
import { absoluteUrl } from "../../seo/siteOrigin";
import { normalizeFulfillmentOptionName } from "./fulfillmentOptionNames";
import {
  REFERRAL_SOURCE_MCQ_OPTIONS,
  REFERRAL_SOURCE_OTHER_MCQ_LABEL,
} from "../../data/referralSourceOptions";
import "./FulfillmentBox.css";

const options = [
  {
    name: "FBA prep centre UK (Amazon)",
    icon: (
<svg fill="#0f172a" height="200px" width="200px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xmlSpace="preserve" stroke="#ffffff"><g strokeWidth="0"></g><g strokeLinecap="round" strokeLinejoin="round"></g><g> <g> <path d="M256,0C114.6,0,0,114.6,0,256s114.6,256,256,256s256-114.6,256-256S397.4,0,256,0z M265.8,171c-3.9-5.7-11.3-8.5-18.1-8.5 h-2.3c-11.3,1.1-21.5,7.3-24.3,19.8c-0.6,2.8-2.3,5.6-5.6,6.2l-31.6-4c-2.3-0.6-5.7-2.2-4.5-6.8c6.8-35.6,37.3-48,66.1-49.7h6.8 c15.8,0,36.2,4.5,49.2,16.4c15.8,14.7,14.1,34.4,14.1,55.9v50.8c0,15.3,6.2,22,12.4,30c1.7,2.8,2.3,6.2-0.6,8.5 c-6.2,5.6-18.1,15.8-24.9,21.5c-2.2,1.7-5.1,1.7-7.9,0.6c-10.7-9-12.4-13-18.6-21.5c-10.7,11.3-19.8,17.5-30.5,20.9 c-6.8,1.7-14.1,2.8-23.1,2.8c-27.1,0-48.6-16.9-48.6-50.3c0-26.5,14.1-44.6,35-53.1c10.7-5.1,23.7-7.3,36.7-9.1 c8.5-1.1,17-1.7,24.3-2.2v-4.5C269.7,186.8,270.3,177.7,265.8,171z M351.3,348.9c-3.3,2.6-6.8,5-10.3,7.1l-0.2,0.1 c-26.7,16.8-61.1,27-91.5,27.7c-0.9,0-1.9,0-2.8,0c-47.8,0-83.4-26.2-115.8-54.4c-1.6-1.3-2.7-3.2-2.7-5.3c0-1.6,0.7-3.2,1.8-4.3 c1.2-1.1,2.7-1.7,4.3-1.7c1.2,0,2.4,0.3,3.6,1c34.6,19.2,68.8,38.7,110.8,38.6c1,0,1.9,0,2.9,0c26.7-0.6,55.5-7.1,83-18.2l0,0 l2.5-1l1.9-0.8c1.3-0.6,2.7-1.2,4.1-1.7c1.2-0.6,2.5-0.9,3.8-0.9c4,0,7.7,3,7.8,7.4C354.8,345,353.4,347.4,351.3,348.9z M367,360.5 c-1.3,1-2.9,1.8-4.7,1.8h-0.1c-1.2,0-2.6-0.4-3.8-1.5c-1.1-1.1-1.7-2.6-1.6-4c0-0.9,0.2-1.7,0.5-2.5c1.2-3.3,3.1-8.2,4.6-13.1 c1.6-4.9,2.7-9.9,2.7-12.6c0-0.7-0.1-1.2-0.1-1.4c0,0-0.1-0.1-0.2-0.1c-0.3-0.1-0.8-0.3-1.5-0.5c-1.4-0.3-3.5-0.5-5.8-0.5 c-3.2,0-7,0.3-10.5,0.7c-4.1,0.6-7.6,0.9-10,1.4h-0.2h-0.2c-0.2,0-0.5,0.1-0.8,0.1c-1.2,0-2.6-0.3-3.8-1.3c-1.2-1-1.9-2.6-1.9-4 c0.1-2.6,1.5-4.3,3.2-5.6c2.8-2,5.7-3.7,9-5v-0.1l2.8-0.9h0.1l4.9-1.6v0.3c4.9-1.1,9.8-1.5,14.2-1.5c6.1,0,11.2,0.7,14.7,2.1 c1.2,0.5,2.3,1,3.4,2.2l0.1,0.2l0.1,0.2c1.1,1.7,1.7,3.7,1.8,6.4l0,0v1.6C383.9,331.4,379.5,349.3,367,360.5z"></path> <path d="M269.7,225.2c-8.5,0-17,0.6-24.3,2.3c-13.6,4-24.3,12.4-24.3,30.5c0,14.1,7.3,23.7,19.8,23.7c1.7,0,3.4-0.6,4.5-0.6 c7.3-1.7,14.1-6.8,18.1-14.7c6.8-11.3,6.2-21.5,6.2-34.5V225.2z"></path> </g> </g></svg>
    )
  },
  {
    name: "Shopify Fulfilment",
    icon: (
      <svg
        width="46"
        height="46"
        viewBox="0 0 1024 1024"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="512" cy="512" r="512" fill="transparent" />
  
        <path
          d="M597.3 308s-6 1.7-15.9 4.7c-1.7-5.6-4.3-12-7.7-18.9-11.2-21.5-27.9-33.1-47.7-33.1-1.3 0-2.6 0-4.3.4-.4-.9-1.3-1.3-1.7-2.1-8.6-9.5-19.8-13.8-33.1-13.3-25.8.9-51.6 19.3-72.2 52.4-14.6 23.2-25.8 52.4-28.8 75.2-29.7 9-50.3 15.5-50.7 15.9-15 4.7-15.5 5.2-17.2 19.3-1.3 10.7-40.8 313.4-40.8 313.4l325 56.3V307.6c-2.7 0-4 .4-4.9.4zm-75.2 23.2c-17.2 5.2-36.1 11.2-54.6 16.8 5.2-20.2 15.5-40.4 27.5-53.7 4.7-4.7 11.2-10.3 18.5-13.8 7.3 15.5 9 36.6 8.6 50.7zm-35.2-67.9c6 0 11.2 1.3 15.5 3.9-6.9 3.4-13.8 9-20.2 15.5-16.3 17.6-28.8 45.1-34 71.4-15.5 4.7-31 9.5-45.1 13.8 9.4-41.4 44.2-103.7 83.8-104.6zM437 499.8c1.7 27.5 74.4 33.5 78.7 98.4 3 51.2-27.1 86-70.5 88.6-52.4 3.4-81.2-27.5-81.2-27.5l11.2-47.3s28.8 21.9 52 20.2c15-.9 20.6-13.3 20.2-21.9-2.1-36.1-61.5-34-65.3-93.3-3.4-49.9 29.2-100.2 101.5-104.9 27.9-1.7 42.1 5.2 42.1 5.2l-16.3 61.9s-18.5-8.6-40.4-6.9c-32 2.1-32.4 22.3-32 27.5zm102.3-173.7c0-12.9-1.7-31.4-7.7-46.9 19.8 3.9 29.2 25.8 33.5 39.1-7.7 2.2-16.3 4.8-25.8 7.8zM612 777.5 747 744s-58-392.5-58.5-395.1c-.4-2.6-2.6-4.3-4.7-4.3s-40-.9-40-.9-23.2-22.4-31.8-31v464.8z"
          fill="#7AB55C"
        />
      </svg>
    )
  },
  {
    name: "TikTok Shop Fulfilment",
    icon: (
    <svg viewBox="-3.2 -3.2 38.40 38.40" fill="none" xmlns="http://www.w3.org/2000/svg"><g strokeWidth="0"><rect x="-3.2" y="-3.2" width="38.40" height="38.40" rx="19.2" fill="transparent" strokeWidth="0"></rect></g><g strokeLinecap="round" strokeLinejoin="round"></g><g> <path d="M8.45095 19.7926C8.60723 18.4987 9.1379 17.7743 10.1379 17.0317C11.5688 16.0259 13.3561 16.5948 13.3561 16.5948V13.2197C13.7907 13.2085 14.2254 13.2343 14.6551 13.2966V17.6401C14.6551 17.6401 12.8683 17.0712 11.4375 18.0775C10.438 18.8196 9.90623 19.5446 9.7505 20.8385C9.74562 21.5411 9.87747 22.4595 10.4847 23.2536C10.3345 23.1766 10.1815 23.0889 10.0256 22.9905C8.68807 22.0923 8.44444 20.7449 8.45095 19.7926ZM22.0352 6.97898C21.0509 5.90039 20.6786 4.81139 20.5441 4.04639H21.7823C21.7823 4.04639 21.5354 6.05224 23.3347 8.02482L23.3597 8.05134C22.8747 7.7463 22.43 7.38624 22.0352 6.97898ZM28 10.0369V14.293C28 14.293 26.42 14.2312 25.2507 13.9337C23.6179 13.5176 22.5685 12.8795 22.5685 12.8795C22.5685 12.8795 21.8436 12.4245 21.785 12.3928V21.1817C21.785 21.6711 21.651 22.8932 21.2424 23.9125C20.709 25.246 19.8859 26.1212 19.7345 26.3001C19.7345 26.3001 18.7334 27.4832 16.9672 28.28C15.3752 28.9987 13.9774 28.9805 13.5596 28.9987C13.5596 28.9987 11.1434 29.0944 8.96915 27.6814C8.49898 27.3699 8.06011 27.0172 7.6582 26.6277L7.66906 26.6355C9.84383 28.0485 12.2595 27.9528 12.2595 27.9528C12.6779 27.9346 14.0756 27.9528 15.6671 27.2341C17.4317 26.4374 18.4344 25.2543 18.4344 25.2543C18.5842 25.0754 19.4111 24.2001 19.9423 22.8662C20.3498 21.8474 20.4849 20.6247 20.4849 20.1354V11.3475C20.5435 11.3797 21.2679 11.8347 21.2679 11.8347C21.2679 11.8347 22.3179 12.4734 23.9506 12.8889C25.1204 13.1864 26.7 13.2483 26.7 13.2483V9.91314C27.2404 10.0343 27.7011 10.0671 28 10.0369Z" fill="#EE1D52"></path> <path d="M26.7009 9.91314V13.2472C26.7009 13.2472 25.1213 13.1853 23.9515 12.8879C22.3188 12.4718 21.2688 11.8337 21.2688 11.8337C21.2688 11.8337 20.5444 11.3787 20.4858 11.3464V20.1364C20.4858 20.6258 20.3518 21.8484 19.9432 22.8672C19.4098 24.2012 18.5867 25.0764 18.4353 25.2553C18.4353 25.2553 17.4337 26.4384 15.668 27.2352C14.0765 27.9539 12.6788 27.9357 12.2604 27.9539C12.2604 27.9539 9.84473 28.0496 7.66995 26.6366L7.6591 26.6288C7.42949 26.4064 7.21336 26.1717 7.01177 25.9257C6.31777 25.0795 5.89237 24.0789 5.78547 23.7934C5.78529 23.7922 5.78529 23.791 5.78547 23.7898C5.61347 23.2937 5.25209 22.1022 5.30147 20.9482C5.38883 18.9122 6.10507 17.6625 6.29444 17.3494C6.79597 16.4957 7.44828 15.7318 8.22233 15.0919C8.90538 14.5396 9.6796 14.1002 10.5132 13.7917C11.4144 13.4295 12.3794 13.2353 13.3565 13.2197V16.5948C13.3565 16.5948 11.5691 16.028 10.1388 17.0317C9.13879 17.7743 8.60812 18.4987 8.45185 19.7926C8.44534 20.7449 8.68897 22.0923 10.0254 22.991C10.1813 23.0898 10.3343 23.1775 10.4845 23.2541C10.7179 23.5576 11.0021 23.8221 11.3255 24.0368C12.631 24.8632 13.7249 24.9209 15.1238 24.3842C16.0565 24.0254 16.7586 23.2167 17.0842 22.3206C17.2888 21.7611 17.2861 21.1978 17.2861 20.6154V4.04639H20.5417C20.6763 4.81139 21.0485 5.90039 22.0328 6.97898C22.4276 7.38624 22.8724 7.7463 23.3573 8.05134C23.5006 8.19955 24.2331 8.93231 25.1734 9.38216C25.6596 9.61469 26.1722 9.79285 26.7009 9.91314Z" fill="#000000"></path> <path d="M4.48926 22.7568V22.7594L4.57004 22.9784C4.56076 22.9529 4.53074 22.8754 4.48926 22.7568Z" fill="#69C9D0"></path> <path d="M10.5128 13.7916C9.67919 14.1002 8.90498 14.5396 8.22192 15.0918C7.44763 15.7332 6.79548 16.4987 6.29458 17.354C6.10521 17.6661 5.38897 18.9168 5.30161 20.9528C5.25223 22.1068 5.61361 23.2983 5.78561 23.7944C5.78543 23.7956 5.78543 23.7968 5.78561 23.798C5.89413 24.081 6.31791 25.0815 7.01191 25.9303C7.2135 26.1763 7.42963 26.4111 7.65924 26.6334C6.92357 26.1457 6.26746 25.5562 5.71236 24.8839C5.02433 24.0451 4.60001 23.0549 4.48932 22.7626C4.48919 22.7605 4.48919 22.7584 4.48932 22.7564V22.7527C4.31677 22.2571 3.95431 21.0651 4.00477 19.9096C4.09213 17.8736 4.80838 16.6239 4.99775 16.3108C5.4985 15.4553 6.15067 14.6898 6.92509 14.0486C7.608 13.4961 8.38225 13.0567 9.21598 12.7484C9.73602 12.5416 10.2778 12.3891 10.8319 12.2934C11.6669 12.1537 12.5198 12.1415 13.3588 12.2575V13.2196C12.3808 13.2349 11.4148 13.4291 10.5128 13.7916Z" fill="#69C9D0"></path> <path d="M20.5438 4.04635H17.2881V20.6159C17.2881 21.1983 17.2881 21.76 17.0863 22.3211C16.7575 23.2167 16.058 24.0253 15.1258 24.3842C13.7265 24.923 12.6326 24.8632 11.3276 24.0368C11.0036 23.823 10.7187 23.5594 10.4844 23.2567C11.5962 23.8251 12.5913 23.8152 13.8241 23.341C14.7558 22.9821 15.4563 22.1734 15.784 21.2774C15.9891 20.7178 15.9864 20.1546 15.9864 19.5726V3H20.4819C20.4819 3 20.4315 3.41188 20.5438 4.04635ZM26.7002 8.99104V9.9131C26.1725 9.79263 25.6609 9.61447 25.1755 9.38213C24.2352 8.93228 23.5026 8.19952 23.3594 8.0513C23.5256 8.1559 23.6981 8.25106 23.8759 8.33629C25.0192 8.88339 26.1451 9.04669 26.7002 8.99104Z" fill="#69C9D0"></path> </g></svg>
    )
  },
  {
    name: "Multi-Channel Fulfilment ",
    icon: (
      <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect width="32" height="32" rx="16" fill="transparent" />
        <rect x="7" y="7" width="7" height="7" rx="1.5" fill="#1a44e5" opacity="0.85" />
        <rect x="18" y="7" width="7" height="7" rx="1.5" fill="#e07b20" opacity="0.9" />
        <rect x="7" y="18" width="7" height="7" rx="1.5" fill="#e07b20" opacity="0.9" />
        <rect x="18" y="18" width="7" height="7" rx="1.5" fill="#1a44e5" opacity="0.85" />
      </svg>
    )
  },
  {
    name: "Fulfilled by Merchant (FBM) / Seller Fulfilled Prime (SFP)",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1a44e5" strokeWidth="2">
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
        <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
        <line x1="12" y1="22.08" x2="12" y2="12"/>
      </svg>
    )
  },
  {
    name: "650+ Other Integrations",
    icon: (
      <svg fill="#1a44e5" viewBox="-192 -192 2304 2304" xmlns="http://www.w3.org/2000/svg">
        <g strokeWidth="0">
          <rect
            x="-192"
            y="-192"
            width="2304"
            height="2304"
            rx="1152"
            fill="#ffffff"
            strokeWidth="0"
          ></rect>
        </g>
        <g strokeLinecap="round" strokeLinejoin="round"></g>
        <g>
          <path
            d="M1581.235 734.118c0 217.976-177.317 395.294-395.294 395.294H960.06c-217.977 0-395.294-177.318-395.294-395.294V564.706h1016.47v169.412Zm225.883-282.353h-338.824V0h-112.941v451.765H790.647V0H677.706v451.765H338.882v112.94h112.942v169.413c0 280.207 228.028 508.235 508.235 508.235h56.47v395.294c0 93.402-76.009 169.412-169.411 169.412-93.403 0-169.412-76.01-169.412-169.412 0-155.633-126.72-282.353-282.353-282.353S113 1482.014 113 1637.647V1920h112.941v-282.353c0-93.402 76.01-169.412 169.412-169.412s169.412 76.01 169.412 169.412c0 155.633 126.72 282.353 282.353 282.353 155.746 0 282.353-126.72 282.353-282.353v-395.294h56.47c280.207 0 508.235-228.028 508.235-508.235V564.706h112.942V451.765Z"
            fillRule="evenodd"
          />
        </g>
      </svg>
    )
  },
];

// Questions configuration for each option
const getQuestionsForOption = (optionName: string) => {
  const questionsConfig: { [key: string]: any[] } = {
    "Amazon FBA Prep": [
      {
        id: "q1",
        type: "mcq-multi",
        label: "What is your primary prep need?",
        options: ["FNSKU Labelling", "Multi-Pack Bundling", "Fragile/Bubble Wrapping", "Carton Forwarding"]
      },
      {
        id: "q2",
        type: "mcq",
        label: "What is your typical monthly shipment volume?",
        options: ["0-500 units", "501-2,000 units", "2,000+ units"]
      },
     
      {
        id: "q3",
        type: "mcq",
        label: "How did you find us?",
        options: REFERRAL_SOURCE_MCQ_OPTIONS
      }      // {
      //   id: "q3",
      //   type: "yesno",
      //   label: "Do you need a same-day turnaround for urgent restocks?"
      // },
      // {
      //   id: "q4",
      //   type: "yesno",
      //   label: "Are you currently facing Amazon Inbound Defect fees or rejected shipments?"
      // }
    ],
    "Shopify Fulfilment": [
      {
        id: "q1",
        type: "mcq",
        label: "How many daily orders does your Shopify store typically process?",
        options: ["0-50", "50-250", "250-500", "500+"]
      },
      {
        id: "q2",
        type: "yesno",
        label: "Does your brand require custom packaging, marketing inserts, or kitting?"
      },
      {
        id: "q3",
        type: "mcq",
        label: "What is your most critical shipping goal?",
        options: ["Branded Experience","Lowest Cost", "Fastest Delivery"]
      },
      {
        id: "q4",
        type: "mcq",
        label: "How did you find us?",
        options: REFERRAL_SOURCE_MCQ_OPTIONS
      },
      // {
      //   id: "q5",
      //   type: "yesno",
      //   label: "Do you need us to manage and inspect customer returns?"
      // }
    ],
    "TikTok Shop Fulfilment": [
      {
        id: "q1",
        type: "mcq",
        label: "How many daily orders does your TikTok Shop typically process?",
        options: ["0-50", "50-250", "250-500", "500+"]
      },
      // {
      //   id: "q2",
      //   type: "yesno",
      //   label: "Do you require automated real-time inventory syncing with our warehouse?"
      // },
      {
        id: "q3",
        type: "yesno",
        label: "Does your brand require custom packaging, marketing inserts, or kitting?"
      },
      {
        id: "q4",
        type: "mcq",
        label: "What is your most critical shipping goal?",
        options: ["Lowest Cost", "Fastest Delivery", "Branded Experience"]
      },
      {
        id: "q5",
        type: "mcq",
        label: "How did you find us?",
        options: REFERRAL_SOURCE_MCQ_OPTIONS
      },
      // {
      //   id: "q5",
      //   type: "yesno",
      //   label: "Do you need us to manage and inspect customer returns?"
      // }
    ],
    "Multi-Channel Fulfilment": [
      {
        id: "q1",
        type: "mcq",
        label: "How many different sales channels do you use?",
        options: ["1-2", "3-5", "6+"]
      },
      {
        id: "q2",
        type: "mcq",
        label: "How many daily orders does your Shopify store typically process?",
        options: ["0-50", "50-250", "250-500", "500+"]
      },
      {
        id: "q3",
        type: "yesno",
        label: "Does your brand require custom packaging, marketing inserts, or kitting?"
      },
      {
        id: "q4",
        type: "mcq",
        label: "What is your most critical shipping goal?",
        options: ["Branded Experience","Lowest Cost", "Fastest Delivery"]
      },
      {
        id: "q5",
        type: "mcq",
        label: "How did you find us?",
        options: REFERRAL_SOURCE_MCQ_OPTIONS
      },
    ],
    "650+ Other Integrations": [
  {
    id: "q1",
    type: "dropdown",
    label: "What platform do you sell on?",
    options: [
      "Amazon",
      "Shopify",
      "eBay",
      "WooCommerce",
      "TikTok Shop",
      "Etsy",
      "Other"
    ]
  },
  {
    id: "q2",
    type: "mcq",
    label: "How many daily orders does your Shopify store typically process?",
    options: ["0-50", "50-250", "250-500", "500+"]
  },
  {
    id: "q3",
    type: "yesno",
    label: "Does your brand require custom packaging, marketing inserts, or kitting?"
  },
  {
    id: "q4",
    type: "mcq",
    label: "What is your most critical shipping goal?",
    options: ["Branded Experience","Lowest Cost", "Fastest Delivery"]
  },
  {
    id: "q5",
    type: "mcq",
    label: "How did you find us?",
    options: REFERRAL_SOURCE_MCQ_OPTIONS
  },
],
    //Fulfilled by Merchant (FBM) / Seller Fulfilled Prime (SFP)
    "Fulfilled by Merchant (FBM) / Seller Fulfilled Prime (SFP)": [
      {
        id: "q1",
        type: "mcq",
        label: "How many daily orders does your Shopify store typically process?",
        options: ["0-50", "50-250", "250-500", "500+"]
      },
      {
        id: "q2",
        type: "yesno",
        label: "Does your brand require custom packaging, marketing inserts, or kitting?"
      },
      {
        id: "q3",
        type: "mcq",
        label: "What is your most critical shipping goal?",
        options: ["Branded Experience","Lowest Cost", "Fastest Delivery"]
      },
      {
        id: "q4",
        type: "mcq",
        label: "How did you find us?",
        options: REFERRAL_SOURCE_MCQ_OPTIONS
      },
    ]
  };

  return questionsConfig[normalizeFulfillmentOptionName(optionName)] || [];
};

/** Formspree uses field names as email labels — use question text, not q1/q2 ids. */
function formspreeFieldLabel(label: string): string {
  return label.trim();
}

function formatAnswerForFormspree(answer: string | string[]): string {
  if (Array.isArray(answer)) return answer.join(", ");
  return String(answer);
}

const FulfillmentBox: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState<string>("");
  const [currentStep, setCurrentStep] = useState<number>(1); // 1 = requirements, 2 = personal
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState<number>(0);
  const [formData, setFormData] = useState<{ [key: string]: string | string[] }>({
    username: "",
    email: "",
    contact: "",
    notes: ""
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [otherInputValue, setOtherInputValue] = useState<string>("");
  const navigate = useNavigate();

  const questions = getQuestionsForOption(selectedOption);
  const currentQuestion = questions[currentQuestionIndex];

  // Lock body scroll when modal is open
  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isModalOpen]);

  const handleButtonClick = (optionName: string) => {
    setSelectedOption(optionName);
    setIsModalOpen(true);
    setIsSubmitted(false);
    setCurrentStep(1);
    setCurrentQuestionIndex(0);
    setOtherInputValue("");
    // Reset form data
    const initialData: { [key: string]: string | string[] } = { username: "", email: "", contact: "" };
    const questionsForOption = getQuestionsForOption(optionName);
    questionsForOption.forEach((q) => {
      initialData[q.id] = q.type === "mcq-multi" ? [] : "";
    });
    setFormData(initialData);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedOption("");
    setCurrentStep(1);
    setCurrentQuestionIndex(0);
    setFormData({ username: "", email: "", contact: "" });
    setOtherInputValue("");
    setIsSubmitted(false);
  };

  const handleNext = () => {
    // Check if current question is answered
    if (!currentQuestion) return;
    
    const value = formData[currentQuestion.id];
    let isAnswered = false;
    
    // Check if "Other (Please specify)" is selected and custom input is filled
    if (value === REFERRAL_SOURCE_OTHER_MCQ_LABEL) {
      isAnswered = Boolean(otherInputValue && otherInputValue.trim() !== "");
      if (isAnswered) {
        // Save the custom input value
        setFormData(prev => ({
          ...prev,
          [currentQuestion.id]: otherInputValue.trim()
        }));
      }
    } else if (currentQuestion.type === "mcq-multi") {
      isAnswered = Array.isArray(value) && value.length > 0;
    } else {
      isAnswered = Boolean(value && String(value).trim() !== "");
    }
    
    if (isAnswered) {
      // Move to next question
      if (currentQuestionIndex < questions.length - 1) {
        setCurrentQuestionIndex(prev => prev + 1);
        setOtherInputValue(""); // Reset other input for next question
      } else {
        // All questions answered, move to step 2
        setCurrentStep(2);
      }
    }
  };

  // Auto-advance for single select questions (MCQ and Yes/No)
  const handleInputChange = (fieldId: string, value: string) => {
    setFormData(prev => ({
      ...prev,
      [fieldId]: value
    }));
    
    // Reset other input if "Other (Please specify)" is not selected
    if (value !== REFERRAL_SOURCE_OTHER_MCQ_LABEL) {
      setOtherInputValue("");
    }
    
    // Auto-advance for single select questions (not multi-select and not "Other")
    const question = questions.find(q => q.id === fieldId);
    if (question && question.type !== "mcq-multi" && value && value !== REFERRAL_SOURCE_OTHER_MCQ_LABEL) {
      // Small delay for better UX
      setTimeout(() => {
        if (currentQuestionIndex < questions.length - 1) {
          setCurrentQuestionIndex(prev => prev + 1);
        } else {
          setCurrentStep(2);
        }
      }, 400);
    }
  };

  const handleBack = () => {
    if (currentStep === 2) {
      // Going back from personal info to questions
      setCurrentStep(1);
      setCurrentQuestionIndex(questions.length - 1); // Go to last question
    } else if (currentQuestionIndex > 0) {
      // Going back to previous question
      setCurrentQuestionIndex(prev => prev - 1);
    }
  };


  const handleMultiSelectChange = (fieldId: string, optionValue: string, checked: boolean) => {
    setFormData(prev => {
      const currentValue = prev[fieldId];
      const currentArray = Array.isArray(currentValue) ? currentValue : [];
      
      let newArray;
      if (checked) {
        newArray = [...currentArray, optionValue];
      } else {
        newArray = currentArray.filter((item: string) => item !== optionValue);
      }
      
      return {
        ...prev,
        [fieldId]: newArray
      };
    });
    // For multi-select, user needs to click Next button manually
  };

  // Map selected option to its corresponding page route
  const getRedirectRoute = (option: string): string => {
    const routeMap: { [key: string]: string } = {
      "Amazon FBA Prep": "/amazon-fba-prep-services",
      "Shopify Fulfilment": "/shopify-fulfillment-services",
      "TikTok Shop Fulfilment": "/tiktok-shop-fulfillment-services",
      "Multi-Channel Fulfilment": "/multi-channel-fulfillment-services",
      "Fulfilled by Merchant (FBM) / Seller Fulfilled Prime (SFP)": "/seller-fulfilled-prime-services",
      "650+ Other Integrations": "/thank-you" // Only this one goes to thank you page
    };
    return routeMap[normalizeFulfillmentOptionName(option)] || "/thank-you"; // Default to thank you if not found
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrorMessage("");

    const controller = new AbortController();
    const timeoutId = window.setTimeout(() => controller.abort(), 60000);

    try {
      const formDataToSubmit = new FormData();

      formDataToSubmit.append("Email", formData.email as string);
      formDataToSubmit.append("Contact Number", (formData.contact as string) || "");
      formDataToSubmit.append("Notes", (formData.notes as string) || "");
      formDataToSubmit.append("Service Selected", selectedOption);

      questions.forEach((question) => {
        const answer = formData[question.id];
        if (answer) {
          formDataToSubmit.append(
            formspreeFieldLabel(question.label),
            formatAnswerForFormspree(answer)
          );
        }
      });

      formDataToSubmit.append("_subject", `New Fulfillment Query: ${selectedOption} from ${formData.email || "Website"}`);
      if (formData.email) {
        formDataToSubmit.append("_replyto", String(formData.email));
      }
      formDataToSubmit.append("_next", absoluteUrl("/thank-you") || FORMSPREE_THANK_YOU_URL);

      const response = await fetch(FORMSPREE_CONTACT_FORM, {
        method: "POST",
        body: formDataToSubmit,
        headers: {
          Accept: "application/json",
        },
        signal: controller.signal,
      });

      if (response.ok) {
        trackLeadSubmission({
          source: 'fulfillment-box',
          email: String(formData.email || ''),
          phone: String(formData.contact || ''),
          message: String(formData.notes || ''),
          extra: {
            serviceSelected: selectedOption,
            answers: Object.fromEntries(
              questions
                .map((q) => [q.label, formData[q.id]])
                .filter(([, v]) => v != null && v !== '')
            ),
          },
        });
        setIsSubmitted(true);
        const redirectRoute = getRedirectRoute(selectedOption);
        setTimeout(() => {
          navigate(redirectRoute);
        }, 2000);
      } else {
        setErrorMessage(await readFormspreeErrorMessage(response));
        setIsSubmitting(false);
      }
    } catch (error) {
      const aborted =
        error instanceof DOMException && error.name === "AbortError";
      setErrorMessage(
        aborted
          ? "Request timed out. Please try again or email info@pickpackpro.co.uk."
          : "Could not reach our form service. Try again or email info@pickpackpro.co.uk. Ad blockers or some networks block form posts even when the site loads normally."
      );
      setIsSubmitting(false);
    } finally {
      window.clearTimeout(timeoutId);
    }
  };

  return (
    <>
      
        <section className="fulfillment-modern-section" aria-labelledby="fulfillment-modern-heading">
          <div className="fulfillment-modern-container">
            {/* Left Column */}
            <div className="fulfillment-modern-left">
              <div className="fulfillment-modern-eyebrow">
                <span className="eyebrow-line"></span>
                OUR FULFILMENT SERVICES
              </div>
              <h2 id="fulfillment-modern-heading" className="fulfillment-modern-title">
                Multi-Channel eCommerce<br />
                Fulfilment &amp; 3PL <span style={{ color: '#1A44E5' }}>Logistics</span>
              </h2>
              <p className="fulfillment-modern-sub">
                UK pick and pack and fulfilment from our Milton Keynes warehouse — same-day dispatch, real-time inventory
                sync and transparent pricing for Amazon, Shopify and TikTok sellers. Compare{' '}
                <Link to="/pricing-fulfilment-services">fulfilment services pricing</Link>, explore our{' '}
                <Link to="/amazon-fba-prep-services">Amazon FBA prep service UK</Link> hub, or read how{' '}
                <Link to="/blog/pick-and-pack-fulfilment-uk-explained">the fulfilment process</Link> works for
                growing ecommerce brands.
              </p>
              <Link to="/contact-fulfillment-services" className="fulfillment-modern-btn">
                Explore our services <span className="arrow">→</span>
              </Link>
              <div className="fulfillment-modern-footer">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                <span>Based in Milton Keynes | UK-wide fulfilment</span>
              </div>
            </div>

            {/* Right Column (Grid) */}
            <div className="fulfillment-modern-right">
              <div className="fulfillment-modern-grid">
                {options.map((option, index) => {
                  let subLabel = "";
                  let shortName = option.name;
                  if (option.name.includes("FBA prep centre")) {
                    shortName = "FBA Prep Centre UK";
                    subLabel = "Amazon";
                  } else if (option.name.includes("Shopify")) {
                    shortName = "Shopify Fulfilment";
                    subLabel = "Shopify";
                  } else if (option.name.includes("TikTok Shop")) {
                    shortName = "TikTok Shop Fulfilment";
                    subLabel = "TikTok Shop";
                  } else if (option.name.includes("Multi-Channel")) {
                    shortName = "Multi-Channel Fulfilment";
                    subLabel = "All marketplaces";
                  } else if (option.name.includes("Fulfilled by Merchant")) {
                    shortName = "Fulfilled by Merchant (FBM) / Seller Fulfilled Prime (SFP)";
                    subLabel = "";
                  } else if (option.name.includes("650+ Other")) {
                    shortName = "650+ Other Integrations";
                    subLabel = "Connect your store";
                  }

                  return (
                    <button type="button" key={index} className="fulfillment-modern-card" onClick={() => handleButtonClick(option.name)}>
                      <div className="modern-card-content">
                        <div className="modern-card-icon">{option.icon}</div>
                        <div className="modern-card-text">
                          <span className="modern-card-title">{shortName}</span>
                          {subLabel && <span className="modern-card-subtitle">{subLabel}</span>}
                        </div>
                      </div>
                      <div className="modern-card-arrow">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#f58030" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                      </div>
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </section>

      {/* Modal */}
      {isModalOpen && (
        <div className="fulfillment-modal-overlay" onClick={handleCloseModal}>
          <div className="fulfillment-modal" onClick={(e) => e.stopPropagation()}>
            {!isSubmitted ? (
              <>
                <div className="fulfillment-modal-header">
                  <h3 className="fulfillment-modal-title">
                    {selectedOption}
                  </h3>
                  <button 
  className="fulfillment-modal-close"
  onClick={handleCloseModal}
  aria-label="Close modal"
>
<svg
    width="32"
    height="32"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#ffffff"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
</button>
                </div>

                {/* Step 1: Requirements Page */}
                {currentStep === 1 && currentQuestion && (
                  <form className="fulfillment-modal-form" onSubmit={(e) => { e.preventDefault(); handleNext(); }}>
                    <div className="fulfillment-step-indicator">
                      <span className="fulfillment-step active">1</span>
                      <span className="fulfillment-step-divider"></span>
                      <span className="fulfillment-step">2</span>
                    </div>
                    <h4 className="fulfillment-page-title">Requirements</h4>
                    <div className="fulfillment-progress-container">
                      <div className="fulfillment-progress-bar">
                        <div 
                          className="fulfillment-progress-fill"
                          style={{ width: `${((currentQuestionIndex + 1) / questions.length) * 100}%` }}
                        ></div>
                      </div>
                      <div className="fulfillment-question-counter">
                        Question {currentQuestionIndex + 1} of {questions.length}
                      </div>
                    </div>
                    <div key={currentQuestion.id} className="fulfillment-form-group">
                      <label className="fulfillment-form-label">{currentQuestion.label}</label>
                      {currentQuestion.type === "yesno" ? (
                        <>
                          <div className="fulfillment-radio-group">
                            <label className="fulfillment-radio-label">
                              <input
                                type="radio"
                                name={currentQuestion.id}
                                value="yes"
                                checked={formData[currentQuestion.id] === "yes"}
                                onChange={(e) => handleInputChange(currentQuestion.id, e.target.value)}
                                required
                              />
                              <span>Yes</span>
                            </label>
                            <label className="fulfillment-radio-label">
                              <input
                                type="radio"
                                name={currentQuestion.id}
                                value="no"
                                checked={formData[currentQuestion.id] === "no"}
                                onChange={(e) => handleInputChange(currentQuestion.id, e.target.value)}
                                required
                              />
                              <span>No</span>
                            </label>
                          </div>
                          {currentQuestionIndex > 0 && (
                            <div className="fulfillment-button-group">
                              <button 
                                type="button"
                                className="fulfillment-back-btn"
                                onClick={handleBack}
                              >
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                Back
                              </button>
                            </div>
                          )}
                        </>
                      ) : currentQuestion.type === "mcq-multi" ? (
                        <>
                          <div className="fulfillment-mcq-group">
                            {currentQuestion.options?.map((option: string) => {
                              const currentValue = formData[currentQuestion.id];
                              const isChecked = Array.isArray(currentValue) && currentValue.includes(option);
                              return (
                                <label key={option} className="fulfillment-mcq-label">
                                  <input
                                    type="checkbox"
                                    value={option}
                                    checked={isChecked}
                                    onChange={(e) => handleMultiSelectChange(currentQuestion.id, option, e.target.checked)}
                                  />
                                  <span>{option}</span>
                                </label>
                              );
                            })}
                          </div>
                          <div className="fulfillment-button-group">
                            {currentQuestionIndex > 0 && (
                              <button 
                                type="button"
                                className="fulfillment-back-btn"
                                onClick={handleBack}
                              >
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                Back
                              </button>
                            )}
                            <button 
                              type="button"
                              className="fulfillment-submit-btn"
                              onClick={handleNext}
                              disabled={!Array.isArray(formData[currentQuestion.id]) || (formData[currentQuestion.id] as string[]).length === 0}
                            >
                              Next
                            </button>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="fulfillment-mcq-group">
                            {currentQuestion.options?.map((option: string) => (
                              <label key={option} className="fulfillment-mcq-label">
                                <input
                                  type="radio"
                                  name={currentQuestion.id}
                                  value={option}
                                  checked={formData[currentQuestion.id] === option}
                                  onChange={(e) => handleInputChange(currentQuestion.id, e.target.value)}
                                  required
                                />
                                <span>{option}</span>
                              </label>
                            ))}
                          </div>
                          {formData[currentQuestion.id] === REFERRAL_SOURCE_OTHER_MCQ_LABEL ? (
                            <div className="fulfillment-other-input-wrapper">
                              <input
                                type="text"
                                className="fulfillment-other-input"
                                placeholder="Please specify"
                                value={otherInputValue}
                                onChange={(e) => setOtherInputValue(e.target.value)}
                                required
                                autoFocus
                              />
                              <div className="fulfillment-button-group">
                                {currentQuestionIndex > 0 && (
                                  <button 
                                    type="button"
                                    className="fulfillment-back-btn"
                                    onClick={handleBack}
                                  >
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    Back
                                  </button>
                                )}
                                <button 
                                  type="button"
                                  className="fulfillment-submit-btn"
                                  onClick={handleNext}
                                  disabled={!otherInputValue || otherInputValue.trim() === ""}
                                >
                                  Next
                                </button>
                              </div>
                            </div>
                          ) : (
                            <div className="fulfillment-button-group">
                              {currentQuestionIndex > 0 && (
                                <button 
                                  type="button"
                                  className="fulfillment-back-btn"
                                  onClick={handleBack}
                                >
                                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                  </svg>
                                  Back
                                </button>
                              )}
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </form>
                )}

                {/* Step 2: Personal Information Page */}
                {currentStep === 2 && (
                  <form 
                    className="fulfillment-modal-form" 
                    onSubmit={handleSubmit}
                    action={FORMSPREE_CONTACT_FORM}
                    method="POST"
                  >
                    <input type="hidden" name="_next" value={absoluteUrl("/thank-you") || FORMSPREE_THANK_YOU_URL} />
                    <div className="fulfillment-step-indicator">
                      <span className="fulfillment-step">1</span>
                      <span className="fulfillment-step-divider"></span>
                      <span className="fulfillment-step active">2</span>
                    </div>
                    <h4 className="fulfillment-page-title">Get your Quote Now</h4>
                    
                    {/* Error Message */}
                    {errorMessage && (
                      <div className="fulfillment-error-message" style={{ 
                        padding: "12px", 
                        marginBottom: "16px", 
                        backgroundColor: "#fee", 
                        color: "#c33", 
                        borderRadius: "8px",
                        fontSize: "14px"
                      }}>
                        {errorMessage}
                      </div>
                    )}

                    <div className="fulfillment-form-group">
                      <label className="fulfillment-form-label" htmlFor="email">Email *</label>
                      <input
                        type="email"
                        id="email"
                        name="Email"
                        className="fulfillment-input"
                        value={formData.email as string}
                        onChange={(e) => handleInputChange("email", e.target.value)}
                        placeholder="Enter your email"
                        required
                      />
                    </div>

                    <div className="fulfillment-form-group">
                      <label className="fulfillment-form-label" htmlFor="contact">Contact Number</label>
                      <input
                        type="tel"
                        id="contact"
                        name="Contact Number"
                        className="fulfillment-input"
                        value={formData.contact as string}
                        onChange={(e) => handleInputChange("contact", e.target.value)}
                        placeholder="Enter your contact number (Optional)"
                      />
                    </div>
                    <div className="fulfillment-form-group">
                      <label className="fulfillment-form-label" htmlFor="notes">Notes</label>
                      <input
                        type="text"
                        id="notes"
                        name="Notes"
                        className="fulfillment-input"
                        value={formData.notes as string}
                        onChange={(e) => handleInputChange("notes", e.target.value)}
                        placeholder="Enter your specific requirements (Optional)"
                      />
                    </div>

                    {/* Hidden fields for question answers */}
                    {questions.map((question) => {
                      const answer = formData[question.id];
                      if (answer) {
                        if (Array.isArray(answer)) {
                          return (
                            <input
                              key={question.id}
                              type="hidden"
                              name={formspreeFieldLabel(question.label)}
                              value={answer.join(", ")}
                            />
                          );
                        } else {
                          return (
                            <input
                              key={question.id}
                              type="hidden"
                              name={formspreeFieldLabel(question.label)}
                              value={String(answer)}
                            />
                          );
                        }
                      }
                      return null;
                    })}
                    
                    {/* Hidden field for selected option */}
                    <input type="hidden" name="Service Selected" value={selectedOption} />

                    <div className="fulfillment-form-actions">
                      <button 
                        type="submit" 
                        className="fulfillment-submit-btn"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <>
                            <svg className="spinner" width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ animation: "spin 1s linear infinite" }}>
                              <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="2" strokeDasharray="32" strokeDashoffset="24" fill="none" opacity="0.3"/>
                            </svg>
                            <span>Sending...</span>
                          </>
                        ) : (
                          "Submit Query"
                        )}
                      </button>
                    </div>
                  </form>
                )}
              </>
            ) : (
              <div className="fulfillment-success-message">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                  <polyline points="22 4 12 14.01 9 11.01"/>
                </svg>
                <h3>Form Submitted Successfully!</h3>
                <p>
                  {selectedOption === "650+ Other Integrations" 
                    ? "Redirecting to thank you page..." 
                    : `Redirecting to ${selectedOption} page...`}
                </p>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default FulfillmentBox;

